import React from 'react'
import Videos from '../Videos';
import { useHistory } from 'react-router-dom'

const DBDA_RA = React.memo(() => {

    const history = useHistory();

    const nextRoute = () => {
        history.push('/question8')
    }

    const title = "RA-Reasoning ability";
    const url = "https://careers4me.in/videos/Reasoning_ability.mp4";

    return (
        <Videos title={title} url={url} onPress={nextRoute} />
    )
});

export default DBDA_RA